
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.8 3.8A6.14 6.14 0 018.14 2h7.72A6.14 6.14 0 0122 8.14v7.72A6.14 6.14 0 0115.86 22H8.14A6.14 6.14 0 012 15.86V8.14c0-1.63.65-3.19 1.8-4.34zm4.34.2A4.14 4.14 0 004 8.14v7.72A4.14 4.14 0 008.14 20h7.72A4.14 4.14 0 0020 15.86V8.14A4.14 4.14 0 0015.86 4H8.14z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.22 7.84a5 5 0 115.56 8.32 5 5 0 01-5.56-8.32zM12 9a3 3 0 100 6 3 3 0 000-6z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M17 6a1 1 0 100 2 1 1 0 000-2z","fill":"#fff"}})])
          )
        }
      }
    